import * as React from "react";

import { TipoGrafico } from "../models/dataModels";
import { I18n } from "../utils/I18n";
import { AccesosContenido } from "../accesos/AccesosContenido";
import { Row, Col } from "reactstrap";

interface EstadisticasProps {
    usuarioId: number;
}

export function TabEstadisiticasContenidos(props: EstadisticasProps): JSX.Element {

    return <div className={"estadisticas"}>
        <h2>{I18n.Strings.estadisticas.accesosLibros}</h2>
        <Row>
            <Col md={12}>
                <AccesosContenido
                    emptyText={I18n.Strings.contenidos.todosSeleccionados}
                    tipo={TipoGrafico.Usuario}
                    usuarioId={props.usuarioId} />
            </Col>
        </Row>
    </div>;
}
